'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var sidePanel = require('./side-panel');

var addEventHandlers = function() {

	appDom.document.on('click', '.js-load-buy-panel', onLoadBuyPanelClicked);
	appDom.document.on('load_buy_panel', onLoadBuyPanelLoginDirective);
 
};

var onLoadBuyPanelLoginDirective = function(e, data) {

	// loadBuyPanel({
	// 	photoId: data.response.photoId,
	// 	activePanel: 'buy_panel'
	// });

	loadBuyPanel({
		photoId: data.response.photoId
	});

};

var loadBuyPanel = function(args) {

	$.ajax({
		url: '?page=buy_panel&eventName=' + dataMgr.getEventName(),
		method: 'POST',
		dataType: 'JSON',
		data: args
	}).done(onLoadBuyPanelDone);

};

var onLoadBuyPanelClicked = function(e) {

	var $el = $(this);
	var index;
	var panel = $el.attr('data-active-panel');
	var saveActivePanel = $el.attr('data-save-active-panel');
	var backBtn = $el.attr('data-back-button-target');
	var packageId = $el.attr('data-selected-package-id');
	var productId = $el.attr('data-selected-product-id');
	var itemKey = $el.attr('data-selected-item-key');
	var args = {
		'activePanel': panel
	};

	if ($el.is('.button--text')) {
		$el.text(window.pbizServer.content.loading);
	}

	if (backBtn) {
		args['backButtonTarget'] = backBtn;
	}


	console.log('**saveActivePanel:');
	console.log(saveActivePanel);

	

	if (saveActivePanel) {
		args['saveActivePanel'] = saveActivePanel;
	} else {
		args['saveActivePanel'] = false;
	}

	if (packageId) {
		args['packageId'] = packageId;
	}

	if (productId) {
		args['productId'] = productId;
	}

	if (itemKey) {
		args['itemKey'] = itemKey;
	}

	// figure out the photo id
	if ($el.attr('data-selected-photo-index')) {

		index = $el.attr('data-selected-photo-index');

		args['photoId'] = dataMgr.getImageMeta(index).photoId;

	} else if ($el.attr('data-selected-photo-id')) {

		args['photoId'] = $el.attr('data-selected-photo-id');

	}

	e.preventDefault();

	e.stopPropagation();

	loadBuyPanel(args);

};

var onLoadBuyPanelDone = function(response) {

	if (response.status.detail === 'contact_access_denied') {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	} else {

		sidePanel.open(response.markup);

	}

};

var init = function() {

	console.log('** init buy-panel.js');

	addEventHandlers();

};

module.exports = {
	init: init
};
